import styles from '../VehicleAllocationColumn.module.scss'
import { Allocation } from '@/types/vehicleAllocation'

export const SwappedBus = ({ allocation }: { allocation: Allocation }) => {
    return (
        <div className={styles.allocationItem}>
            <div className={styles.run}>{allocation.run}</div>

            <div className={styles.bonnet}>
                <button className={styles.editManualButton}>{allocation.bonnet}</button>
            </div>
        </div>
    )
}
